export default function Logo() {
  return (
    <div className="flex items-center gap-1.5 select-none">
      <div className="w-8 h-8 rounded-lg bg-emerald-500 flex items-center justify-center">
        <span className="text-white font-bold text-sm">Y</span>
      </div>
      <div>
        <span className="text-xl font-extrabold tracking-wide text-slate-900 dark:text-white">
          YALA
        </span>
        <span className="text-xl font-extrabold tracking-wide text-emerald-600 dark:text-emerald-400 ml-1">
          MOBILITY
        </span>
      </div>
    </div>
  );
}
